import { CssBaseline } from "@material-ui/core";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import React from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DataLoading from "./components/shared/DataLoading";
import routes from "./routes";

gsap.registerPlugin(ScrollTrigger);

const App = () => {
    const { loading } = useSelector((state) => state.site);

    return (
        <BrowserRouter>
            <CssBaseline />
            <ToastContainer />
            {loading && <DataLoading />}
            <Switch>
                {routes.map((route, i) => (
                    <Route
                        key={i}
                        path={route.path}
                        exact
                        component={route.component}
                    />
                ))}
            </Switch>
        </BrowserRouter>
    );
};

export default App;
